import { render, staticRenderFns } from "./monthlyWageStatistics.vue?vue&type=template&id=cbc4a03e&scoped=true&"
import script from "./monthlyWageStatistics.vue?vue&type=script&lang=js&"
export * from "./monthlyWageStatistics.vue?vue&type=script&lang=js&"
import style0 from "./monthlyWageStatistics.vue?vue&type=style&index=0&id=cbc4a03e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc4a03e",
  null
  
)

export default component.exports